module.exports = __webpack_public_path__ + "images/areamap/btn_mappin_chubu_sp_a6a6991e06cfdda205207e801d073bb5.png";